import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ActivationEnd, NavigationEnd, Router} from '@angular/router';
import {AuthComponent} from 'projects//paid_ukr/src/app/components/auth/auth.component';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../environments/environment';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ConfirmSignInComponent} from 'projects//paid_ukr/src/app/components/auth/confirm-sign-in/confirm-sign-in.component';
import {AiAssistantService} from '../../../../shared/src/lib/components/ai-assistant/ai-assistant.service';
import {FlowTypeService} from '../../../../shared/src/lib/services/flow-type.service';
import {FeaturesService} from '../../../../shared/src/lib/services/features.service';
import {PayedService} from '../../../../paid/src/app/services/payed.service';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
    testName = 'anxiety';
    isProd = environment.production;
    v = environment.appVersion;
    isHomePage = false;
    isForBusiness = false;


    latestResultId = null;
    isAiSubscription = false;
    isSubscription = false;
    isAiChat = false;

    showStartTestButton = false;
    showAiStartTestButton = false;
    currentPosition = window.scrollY;

    progress = null;
    showNav = false;

    @ViewChild('header') header: ElementRef;

    @HostListener('window:scroll', ['$event.target']) // for window scroll events
    scroll(e) {
        const scroll = e.scrollingElement.scrollTop;
        if (scroll > 35) {
            e.getElementsByTagName('app-nav')[0].classList.add('scroll');
        } else {
            e.getElementsByTagName('app-nav')[0].classList.remove('scroll');
        }
        this.currentPosition = scroll;
    }

    constructor(
        public auth: AuthService,
        public data: DataService,
        private router: Router,
        private modalService: NgbModal,
        private aiService: AiAssistantService,
        public feature: FeaturesService,
        private flowTypeService: FlowTypeService,
        public payed: PayedService,
        public afAuth: AngularFireAuth,
        private deviceService: DeviceDetectorService,
    ) {

        router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.isHomePage = event.url === '/';
            }
            if (event instanceof ActivationEnd) {
                this.auth.$userSessions.subscribe((res: any) => {
                    this.progress = res;
                });
                const showStart = event.snapshot?.firstChild?.firstChild?.firstChild?.data?.showStart;
                const showAiStart = event.snapshot?.firstChild?.firstChild?.firstChild?.data?.showAiStart;
                this.showStartTestButton = event.snapshot.data?.showStart || showStart;
                this.showAiStartTestButton = event.snapshot.data?.showAiStart || showAiStart;
                this.isForBusiness = event.snapshot.data?.showContactForDemo;
            }
        });
        this.data.$latestResultId.subscribe((res) => {
                this.latestResultId = res;
        });
    }

    ngOnInit(): void {
        this.isAiChat = this.flowTypeService.state === 'ai';
        this.isAiSubscription = this.aiService.isAiSubscription;
        this.isSubscription = this.aiService.isSubscription;


        const url = window.location.href;
        const email: any = window.localStorage.getItem('emailForSignIn');

        if (url.includes('login')) {
            if (!email) {
                this.openConfirmModal(url)
                    .then(() => {
                        this.confirmSignIn(email, url);
                    });
            } else {
                this.confirmSignIn(email, url);
            }
        }
    }

    confirmSignIn(email, url) {
        this.auth.confirmSignIn(email, url)
            .then((res) => {
                if (res === 'auth/invalid-link') {
                    this.openAuthModal();
                }
            }, () => {
            });
    }

    get isLoggedIn(): boolean {
        return this.auth?.isLoggedIn;
    }

    openAuthModal() {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        modalRef.result.then(
            (res: any) => {
                // if (res) {
                //     this.goToTest();
                // } else {
                //
                // }
                this.router.navigate([])
                    .then();
            },
            () => {
                // this.fetchLockedSlots();
            }
        );
    }

    get isMobile() {
        return this.deviceService.isMobile();
    }

    openConfirmModal(url) {
        const modalRef = this.modalService.open(ConfirmSignInComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        modalRef.componentInstance.url = url;
        return modalRef.result;
    }

    startTest() {
        if (this.isLoggedIn) {
            this.goToTest();
        } else {
            this.openAuthModal();
        }
    }

    goToTest() {
        return this.router.navigate(
            [!this.isAiChat || this.payed.isPayed() ? '/cs' : '/pricing'],
            {
                state: {
                    name: this.testName
                }
            });
    }

    onSignOut() {
        this.auth?.SignOut()
            .then();
    }
}
